import React from 'react';
import { Badge, Icon, Text } from '@chakra-ui/react';
import { FiMapPin, FiVideo, FiGlobe } from 'react-icons/fi';

interface CourseTypeBadgeProps {
  hasOnline: boolean;
  hasStudio: boolean;
  locationText: string;
  size?: 'sm' | 'md' | 'lg';
}

const CourseTypeBadge: React.FC<CourseTypeBadgeProps> = ({
  hasOnline,
  hasStudio,
  locationText,
  size = 'sm',
}) => {
  // Determine variant and content based on course types
  let variant: 'online' | 'studio' | 'mixed';
  let icon;
  let text;

  if (hasOnline && hasStudio) {
    // Mixed group - show location/online
    variant = 'mixed';
    icon = FiGlobe;
    text = locationText ? `${locationText}` : 'Online';
  } else if (hasOnline) {
    // Online only
    variant = 'online';
    icon = FiVideo;
    text = 'Online';
  } else {
    // Studio only (default)
    variant = 'studio';
    icon = FiMapPin;
    text = locationText === 'Studio' ? 'Studio' : locationText || 'Studio';
  }

  return (
    <Badge variant={variant} size={size}>
      <Icon as={icon} size="12px" />
      <Text pt={1}>{text}</Text>
    </Badge>
  );
};

export default CourseTypeBadge;
